<template>
  <div>
    <mavon-editor ref=md v-model="content"
                  :toolbars="markdownOption"
                  codeStyle="default"
                  :subfield="subfield"
                  :defaultOpen="defaultOpen"
                  :toolbarsFlag="toolbarsFlag"
                  :editable="editable"
                  :scrollStyle="true"
                  :ishljs="true"
                  @imgAdd="imgAdd"
                  @imgDel="imgDel"
                  :style="editable?{height: height+'px'}:''"/>

  </div>
</template>

<script>

import {mavonEditor} from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import {removeBlogImage} from '../../../request/api'
import axios from 'axios'
import Common from '../../../js/Common'

export default {
  name: 'MavonEditor',
  components: {mavonEditor},
  props: {
    data: Object
  },
  data () {
    return {
      height: 0,
      blogid: '', // 创建ID
      title: '', // blog标题
      defaultOpen: 'preview',
      toolbarsFlag: false,
      editable: false,
      subfield: false,
      tags: [], // blog标签数据
      chooseTags: [], // blog输入的标签
      content: '',
      // content: 'qs是一个npm仓库所管理的包,可通过npm install qs命令进行安装.\n' +
      //   '\n' +
      //   '1.qs.parse()将URL解析成对象的形式\n' +
      //   '```js\n' +
      //   'const Qs = require(\'qs\');\n' +
      //   'let url = \'method=query_sql_dataset_data&projectId=85&appToken=7d22e38e-5717-11e7-907b-a6006ad3dba0\';\n' +
      //   'Qs.parse(url);\n' +
      //   'console.log(Qs.parse(url));\n' +
      //   '```\n' +
      //   '如上面代码所示,输出结果如下:\n' +
      //   '```json\n' +
      //   '{\n' +
      //   '    method:\'query_sql_dataset_data\',\n' +
      //   '    projectId:\'85\',\n' +
      //   '    appToken:\'7d22e38e-5717-11e7-907b-a6006ad3dba0\'\n' +
      //   '}\n' +
      //   '```\n' +
      //   '\n' +
      //   '2. qs.stringify()将对象 序列化成URL的形式，以&进行拼接\n' +
      //   '```js\n' +
      //   'const Qs = require(\'qs\');\n' +
      //   'let obj= {\n' +
      //   '     method: "query_sql_dataset_data",\n' +
      //   '     projectId: "85",\n' +
      //   '     appToken: "7d22e38e-5717-11e7-907b-a6006ad3dba0",\n' +
      //   '     datasetId: " 12564701"\n' +
      //   '   };\n' +
      //   'Qs.stringify(obj);\n' +
      //   'console.log(Qs.stringify(obj));\n' +
      //   '```\n' +
      //   '如上面代码所示,输出结果如下:\n' +
      //   '```\n' +
      //   'method=query_sql_dataset_data&projectId=85&appToken=7d22e38e-5717-11e7-907b-a6006ad3dba0&datasetId=12564701\n' +
      //   '\n' +
      //   '```\n' +
      //   '那么当我们需要传递数组的时候，我们就可以通过下面方式进行处理：\n' +
      //   '默认情况下，它们给出明确的索引，如下代码：\n' +
      //   '\n' +
      //   '```js\n' +
      //   'qs.stringify({ a: [\'b\', \'c\', \'d\'] });\n' +
      //   '// \'a[0]=b&a[1]=c&a[2]=d\'\n' +
      //   '```\n' +
      //   '也可以进行重写这种默认方式为false\n' +
      //   '```js\n' +
      //   'qs.stringify({ a: [\'b\', \'c\', \'d\'] }, { indices: false });\n' +
      //   '// \'a=b&a=c&a=d\'\n' +
      //   '```\n' +
      //   '当然，也可以通过arrayFormat 选项进行格式化输出，如下代码所示：\n' +
      //   '\n' +
      //   '```js\n' +
      //   'qs.stringify({ a: [\'b\', \'c\'] }, { arrayFormat: \'indices\' })\n' +
      //   '// \'a[0]=b&a[1]=c\'\n' +
      //   'qs.stringify({ a: [\'b\', \'c\'] }, { arrayFormat: \'brackets\' })\n' +
      //   '// \'a[]=b&a[]=c\'\n' +
      //   'qs.stringify({ a: [\'b\', \'c\'] }, { arrayFormat: \'repeat\' })\n' +
      //   '// \'a=b&a=c\'\n' +
      //   '```\n' +
      //   '在这里需要注意的是，JSON中同样存在stringify方法，但是两者之间的区别是很明显的，如下所示：\n' +
      //   '\n' +
      //   '```js\n' +
      //   '{"uid":"cs11","pwd":"000000als","username":"cs11","password":"000000als"}\n' +
      //   'uid=cs11&pwd=000000als&username=cs11&password=000000als\n' +
      //   '```\n' +
      //   '如上所示，前者是采用JSON.stringify(param)进行处理，后者是采用Qs.stringify(param)进行处理的。\n' +
      //   '\n' +
      //   '\n' +
      //   '\n' +
      //   '\n' +
      //   '\n', // blog内容
      topping: false, // 置顶
      essence: false, // 精华
      hidden: false, // 隐私
      md: null, // markdown-it
      markdownOption: {
        // toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: false, // 全屏编辑
        readmodel: false, // 沉浸式阅读
        htmlcode: false, // 展示html源码
        help: false, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: false, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: false, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: false, // 单双栏模式
        preview: true // 预览
      }
    }
  },
  mounted () {
    this.md = mavonEditor.getMarkdownIt()
    console.log(this.md)
    // this.id = this.data.blogId
    // console.log(this.data.blogId)
    // this.md.set({ breaks: false })

    // this.md.use(require('markdown-it-container'), 'spoiler', {
    //
    //   validate: function (params) {
    //     return params.trim().match(/^spoiler\s+(.*)$/)
    //   },
    //
    //   render: function (tokens, idx) {
    //     var m = tokens[idx].info.trim().match(/^spoiler\s+(.*)$/)
    //
    //     if (tokens[idx].nesting === 1) {
    //       // opening tag
    //       return '<details><summary>' + 111 + '</summary>\n'
    //     } else {
    //       // closing tag
    //       return '</details>\n'
    //     }
    //   }
    // })
    //
    // console.log(this.md.render('::: spoiler click me\n*content*\n:::\n'))
  },
  methods: {

    imgAdd (pos, file) {
      console.log(pos)

      var formData = new FormData()
      formData.append('id', this.blogid)
      formData.append('image', file)
      const newRequest = axios.create({

      })
      newRequest({
        method: 'POST',
        url: Common.uploadBlogImage(),
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime(),
          'accessToken': localStorage.getItem(Common.userToken)
        }
      }).then(res => {
        console.log(res)

        if (res.data.code === '90') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.$refs.md.$img2Url(pos, Common.resourceUrl + 'Blog/' + this.blogid + '/' + res.data.data)
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    },
    imgDel (pos) {
      console.log(pos[0])

      var imgStr = pos[0].slice((Common.resourceUrl + 'Blog/').length)

      console.log(imgStr)

      var params = {'image': imgStr}

      removeBlogImage(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    }

  },
  created () {
    // 动态设置内容高度 让footer始终居底
    this.height = document.documentElement.clientHeight - 466
    // 监听浏览器窗口变化
    window.onresize = () => { this.height = document.documentElement.clientHeight - 466 }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/widgets/MavonEditor.vue